import * as React from 'react'
import { Typography, Grid, Box, Button} from '@mui/material'
import { pdf } from '@react-pdf/renderer'
import FileSaver from 'file-saver'
import { ExamplePDF } from '../../letters/Example'

export const EditPDF = () =>{




const clickDownload = async () =>{
const blob =  await pdf(ExamplePDF({number: 5})).toBlob()

FileSaver.saveAs(blob, 'example.pdf')
}


return(

<Box sx={{minHeight:'80vh', mt: 15}}>
    <Grid container direction='column' sx={{justifyContent: 'center', alignItems: 'center'}} >
    <Grid size={{xs: 10, sm: 8, lg: 6, xl: 4}} sx={{mt: 2}}>    
        <Typography color='primary' variant='body2'>Edit PDF Admin Page</Typography>
    </Grid>
   
    
     <Grid size={{xs: 10, sm: 8, lg: 6, xl: 4}} sx={{mt: 2}}>
        <Button type='button' onClick={clickDownload}>Download</Button>
    </Grid> 
    </Grid>
</Box>


)}